import bowser from 'bowser';

export function mixin(Hop) {
    Hop.getBrowserDesc = function () {
        let browser = bowser;
        if (browser.browser) {
            browser = browser.browser;
        }
        return browser || {};
    };
}
